"use client";
import { Button } from "@/components/ui/button";
import Link from "next/link";

export default function Error({ error, reset }) {
  return (
    <html>
      <body>
        <section className="bg-white mt-10">
          <div className="container flex items-center min-h-screen px-6 py-12 mx-auto">
            <div>
              <p className="text-sm font-semibold text-brand-sky">
                404 error
              </p>
              <h1 className="mt-3 text-2xl font-semibold text-brand-navy md:text-3xl">
                We can&apos;t find that page
              </h1>
              <p className="mt-4 text-muted-foreground">{error}</p>

              <div className="flex items-center mt-6 gap-x-3">
                <Button
                  onClick={() => reset()}
                  variant="outline"
                  className="border-brand-sky text-brand-deep hover:bg-brand-sky hover:text-white transition-colors rounded-xl font-semibold"
                >
                  Try again
                </Button>
                <Link href="/">
                  <Button className="gradient-primary hover:opacity-95 text-white rounded-xl font-semibold shadow-brand hover:shadow-brand-lg transition-all px-6">
                    Take me home
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </body>
    </html>
  );
}